module.exports = __webpack_public_path__ + "assets/img/2001.ed09cf43.png";